const initialState = window.innerWidth < 900;

function isMobileReducer(state = initialState, action) {
  switch (action.type) {
    case "isMobile/update":
      return action.payload;
    default:
      return state;
  }
}

export default isMobileReducer;
